import React from 'react'
import { AvaWrapper } from './styles'
import { SERVER_URL } from 'fixtures/api'

const ic_profile = require('App/assets/images/ic_profile.png')

const getAvatar = (row) => {
  if (row && row.hasOwnProperty('displayPicture') && row.displayPicture) {
    return `${SERVER_URL}${row.displayPicture.thumbnailUrl}`
  } else {
    return ic_profile
  }
}

export const imgFormatter = (cell, row, rowIndex, formatExtraData) => {
  return (
    <div>
      <AvaWrapper src={getAvatar(row)} />
    </div>
  )
}
